import { TransformKind, type CropParams, type ImageNode } from '@/core/document'
import type { EditSessionState } from '@/core/store/editSession'
import { selectSelectedNode } from '@/core/store/selectors'

export function selectSelectedImageNode(state: EditSessionState): ImageNode {
  const node = selectSelectedNode(state)
  return node
}

export function selectSelectedCrop(state: EditSessionState): CropParams {
  const node = selectSelectedImageNode(state)
  const crop = node.transforms[TransformKind.Crop]
  if (!crop) throw new Error(`Image node "${node.id}" has no Crop transform`)
  return crop
}
